<template>
    <AppLayout :contrast="true" :title="`Envío #${envio.seguimiento}`">
        <Toast />
        <XyzTransition appear xyz="fade">
            <Breadcrumb
                name="Envíos"
                routeName="envios"
                :page="`Detalles de envío #${envio.seguimiento}`"
            />
        </XyzTransition>
        <div class="w-full flex flex-col lg:flex-row">
            <div class="flex flex-col w-full lg:w-1/2">
                <XyzTransition appear xyz="fade">
                    <LogisticsPanel
                        :envio="envio"
                        :proveedores="proveedores"
                        :sucursal="sucursal"
                    />
                </XyzTransition>

                <XyzTransition appear xyz="fade">
                    <OriginPanel :envio="envio" />
                </XyzTransition>

                <XyzTransition appear xyz="fade">
                    <DestinationPanel :envio="envio" />
                </XyzTransition>
            </div>

            <div class="flex flex-col lg:w-1/2">
                <XyzTransition appear xyz="fade">
                    <div
                        class="bg-white flex flex-col rounded-lg shadow-md p-5 lg:p-8 m-2 lg:mx-4"
                    >
                        <div class="font-semibold text-gray-600 text-xl mb-6">
                            Opciones
                        </div>
                        <div class="flex flex-col lg:flex-col space-y-2">
                            <TextButton
                                @click="openReadyToPickupDialog"
                                :loading="readyTopickupLoading"
                                v-tooltip.left="
                                    envio.listo_para_recolectar == '1'
                                        ? 'Envío ya fue marcado'
                                        : 'Marcar envío como listo para recolectar'
                                "
                                :disabled="
                                    envio.listo_para_recolectar == '1'
                                        ? true
                                        : false
                                "
                            >
                                <div
                                    class="flex items-center justify-start space-x-2"
                                >
                                    <Icon size="20">
                                        <Check />
                                    </Icon>
                                    <span>Listo para recolectar</span>
                                </div>
                            </TextButton>
                            <TextButton
                                @click="downloadManifest"
                                :loading="manifestDowloadLoading"
                                v-if="this.envio.listo_para_recolectar === 1"
                                spinnerColor="gray"
                            >
                                <div
                                    class="flex items-center justify-start space-x-2"
                                >
                                    <Icon size="20">
                                        <ClipboardList />
                                    </Icon>
                                    <span>Descargar remito</span>
                                </div>
                            </TextButton>
                            <TextButton @click="openOptionsDialog">
                                <div
                                    class="flex items-center justify-start space-x-2"
                                >
                                    <Icon size="20">
                                        <Truck />
                                    </Icon>
                                    <span>Solicitar cambio o devolución</span>
                                </div>
                            </TextButton>
                            <TextButton
                                variant="destructive"
                                @click="openDeleteShipmentDialog"
                            >
                                <div
                                    class="flex items-center justify-start space-x-2"
                                >
                                    <Icon size="15">
                                        <Trash />
                                    </Icon>
                                    <span>Eliminar envío</span>
                                </div>
                            </TextButton>
                        </div>
                    </div>
                </XyzTransition>
                <XyzTransition appear xyz="fade">
                    <div
                        class="bg-white rounded-lg shadow-md p-5 lg:p-8 m-2 lg:mx-4"
                    >
                        <div class="flex justify-between items-center mb-4">
                            <div
                                class="font-semibold text-gray-600 text-xl mb-4"
                            >
                                Historial de estados
                            </div>
                            <Button
                                variant="dismissive"
                                v-tooltip.top="'Actualizar'"
                                @click="fetchShipmentHistory(envio.seguimiento)"
                            >
                                <Icon size="20">
                                    <Refresh />
                                </Icon>
                            </Button>
                        </div>

                        <template v-if="loadingHistory">
                            <div class="h-64 w-full flex justify-center">
                                <div
                                    class="w-16 h-16 rounded-full animate-spin border-4 border-solid border-primary-500 border-t-transparent"
                                ></div>
                            </div>
                        </template>
                        <template v-else>
                            <XyzTransition appear xyz="fade">
                                <DataTable
                                    :value="shippingHistory"
                                    responsiveLayout="scroll"
                                    dataKey="fechahora"
                                    style="min-height: 300px"
                                >
                                    <template #empty>
                                        Ha ocurrido un error...
                                    </template>
                                    <Column header="Fecha">
                                        <template #body="slotProps">
                                            <div class="text-[11px]">
                                                {{ slotProps.data.fecha }}
                                            </div>
                                        </template>
                                    </Column>
                                    <Column
                                        field="estado"
                                        header="Estado"
                                    ></Column>
                                    <Column
                                        field="detalle"
                                        header="Detalles"
                                    ></Column>
                                </DataTable>
                            </XyzTransition>
                        </template>
                    </div>
                </XyzTransition>

                <XyzTransition appear xyz="fade">
                    <div
                        class="bg-white rounded-lg shadow-md p-5 lg:p-8 m-2 lg:mx-4"
                    >
                        <div class="font-semibold text-gray-600 text-lg mb-4">
                            Detalles de compra
                        </div>
                        <DataTable :value="envio.productos">
                            <Column header="Desc" field="descripcion" />
                            <!-- <Column header="Precio" field="precio" /> -->
                            <Column header="Kg" field="peso_real" />
                            <Column header="Alto" field="alto" />
                            <Column header="Largo" field="largo" />
                            <Column header="Ancho" field="ancho" />
                            <Column header="Vol" field="peso_volumetrico" />
                        </DataTable>
                    </div>
                </XyzTransition>
            </div>
        </div>
        <!-- Confirmar marcar como listo para recolectar  -->
        <Dialog
            v-model:visible="confirmReadyToPickupDialog"
            :style="{ margin: '0 10px', maxWidth: '400px' }"
            header="Confirmar"
            :modal="true"
        >
            <div class="flex items-center justify-center">
                <span>
                    ¿Seguro que deseas marcar el envío #{{ envio.seguimiento }}
                    como listo para recolectar?
                </span>
            </div>
            <template #footer>
                <div class="flex justify-end space-x-2">
                    <Button
                        variant="dismissive"
                        @click="confirmReadyToPickupDialog = false"
                    >
                        Cancelar
                    </Button>
                    <Button
                        :loading="readyTopickupLoading"
                        @click="handleReadyToPickup"
                    >
                        Confirmar
                    </Button>
                </div>
            </template>
        </Dialog>
        <!-- Confirmar borrar envio -->
        <Dialog
            v-model:visible="confirmDeleteShipmentDialog"
            :style="{ width: '450px' }"
            header="Confirmar eliminar"
            :modal="true"
        >
            <div class="flex items-center justify-center">
                <i
                    class="pi pi-exclamation-triangle mr-3"
                    style="font-size: 2rem"
                />
                <span>
                    ¿Seguro que deseas eliminar el envío #
                    {{ envio.seguimiento }}?
                </span>
            </div>
            <template #footer>
                <div class="flex justify-end space-x-2">
                    <Button
                        variant="dismissive"
                        @click="confirmDeleteShipmentDialog = false"
                    >
                        Cancelar
                    </Button>
                    <Button variant="destructive" @click="handleDeleteShipment">
                        Eliminar
                    </Button>
                </div>
            </template>
        </Dialog>
        <ReturnChangeDialog
            :openDialog="optionsDialog"
            :envio="envio"
            @closeDialog="closeReturnDialog"
            @onSuccessfulChange="onSuccessfulChange"
            @onSuccessfulReturn="onSuccessfulReturn"
            @onDisplayErrors="onDisplayErrors"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import TrackingColumn from "./components/TrackingColumn.vue";
import Button from "@/shared/Button.vue";
import TextButton from "@/shared/TextButton.vue";
import formatDate from "../../helpers/formatDate";
import LogisticsPanel from "./components/show/LogisticsPanel.vue";
import OriginPanel from "./components/show/OriginPanel.vue";
import DestinationPanel from "./components/show/DestinationPanel.vue";
import ReturnChangeDialog from "./components/show/ReturnChangeDialog.vue";

import { Icon } from "@vicons/utils";
import { ArrowUndo, Refresh } from "@vicons/ionicons5";
import { Check, Bookmark, Truck, Trash } from "@vicons/fa";
import {
    ArrowsLeftRight,
    ArrowNarrowLeft,
    ClipboardList,
} from "@vicons/tabler";
import { Inertia } from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        Breadcrumb,
        LogisticsPanel,
        OriginPanel,
        DestinationPanel,
        Button,
        TextButton,
        ReturnChangeDialog,
        Icon,
        ArrowUndo,
        Refresh,
        TrackingColumn,
        Check,
        Bookmark,
        Truck,
        Trash,
        ArrowsLeftRight,
        ArrowNarrowLeft,
        ClipboardList,
    },
    props: {
        envio: Object,
        proveedores: Object,
        sucursal: Object,
    },
    data() {
        return {
            shippingHistory: [],
            loadingHistory: false,
            readyTopickupLoading: false,
            confirmReadyToPickupDialog: false,
            confirmDeleteShipmentDialog: false,
            optionsDialog: false,
            manifestDowloadLoading: false,
        };
    },
    mounted() {
        this.fetchShipmentHistory(this.envio.seguimiento);
    },
    methods: {
        formatDate,
        openReadyToPickupDialog() {
            this.confirmReadyToPickupDialog = true;
        },
        openDeleteShipmentDialog() {
            this.confirmDeleteShipmentDialog = true;
        },
        reloadProps() {
            Inertia.reload({
                only: ["envio"],
                // onError: () =>
                //     this.dispatchNotification({
                //         severity: "error",
                //         summary: "Ha ocurrido un error",
                //         detail: "Intenta más tarde",
                //         life: 3000,
                //     }),
            });
        },
        fetchShipmentHistory(seguimiento) {
            this.loadingHistory = true;
            axios
                .get("/envios/consultar-estado/" + seguimiento)
                .then((res) => {
                    this.shippingHistory = res.data;
                    this.loadingHistory = false;
                })
                .catch((err) => {
                    console.error(err);
                    //   this.$emit("dispatchNotification", {
                    //     severity: "error",
                    //     summary: "Ha ocurrido un error",
                    //     detail: "Intenta más tarde",
                    //     life: 3000,
                    //   });
                    this.loading = false;
                });
        },

        handleReadyToPickup() {
            this.readyTopickupLoading = true;
            axios
                .post("/envios/marcar-listo-recolectar", {
                    envios: [this.envio.seguimiento],
                })
                .then((res) => {
                    if (res.data.success) {
                        this.reloadProps();
                        this.confirmReadyToPickupDialog = false;
                        this.downloadManifest();
                    }
                    this.readyTopickupLoading = false;
                })
                .catch((err) => {
                    console.error(err.message);
                    this.readyTopickupLoading = false;
                });
        },
        handleDeleteShipment() {
            Inertia.delete("/envios/" + this.envio.seguimiento);
        },
        openOptionsDialog() {
            this.optionsDialog = true;
        },
        closeReturnDialog() {
            this.optionsDialog = false;
        },
        onSuccessfulReturn(message) {
            this.$toast.add({
                severity: "success",
                summary: message,
                life: 3000,
            });
            this.sleep(4000).then(() => {
                this.$inertia.visit("/envios");
            })
        },
        onSuccessfulChange(message) {
            this.$toast.add({
                severity: "success",
                summary: message,
                life: 3000,
            });
            this.sleep(4000).then(() => {
                this.$inertia.visit("/envios");
            })
        },
        onDisplayErrors(message) {
            this.$toast.add({
                severity: "error",
                summary: message,
                life: 3000,
            });
        },
        downloadManifest() {
            this.manifestDowloadLoading = true;
            axios
                .post("/envios/descargar-remito", {
                    envios: [this.envio.seguimiento],
                })
                .then((res) => {
                    let manifest = document.createElement("a");
                    manifest.href =
                        "data:application/octet-stream;base64," + res.data.pdf;
                    manifest.download = `shipro_remito_${this.envio.seguimiento}.pdf`;
                    manifest.click();
                    this.manifestDowloadLoading = false;
                })
                .catch((err) => {
                    console.log(err.message);
                    this.manifestDowloadLoading = false;
                });
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
    },
};
</script>
